import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Observable, map } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { NavigationComponent } from './navigation/navigation.component';
import { NavigationProfileComponent } from './navigation-profile/navigation-profile.component';
import { MatButtonModule } from '@angular/material/button';
import { SiteContextService } from '../../../core/site-context.service';

@Component({
    selector: 'mce-page-with-navigation',
    imports: [NavigationComponent, NavigationProfileComponent, MatButtonModule, MatSidenavModule, MatToolbarModule, MatIconModule],
    templateUrl: './page-with-navigation.component.html'
})
export class PageWithNavigationComponent {

  private breakpointObserver = inject(BreakpointObserver);
  private siteContext = inject(SiteContextService);
  private router = inject(Router);

  private isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  private isHandset = toSignal(this.isHandset$);

  private isSmall$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Small)
    .pipe(map(result => result.matches));

  private isSmall = toSignal(this.isSmall$);


  private titleMap: { [key: string]: string; } = {
    '/dashboard': 'Dashboard',
    '/projects': 'Projects',
    '/cables': 'Cables',
    '/settings': 'Settings',
    '/help': 'Help',
    '/administration': 'Site Administration',
    '/license/admin': 'License Administration',
    '/account': 'Account',
    '/profile/edit': 'Your Profile'
  };

  protected title = this.router.url.startsWith('/cables/')
    ? 'Cables'
    : this.titleMap[this.router.url] || 'Cable Engineering';


  protected readonly viewModel = computed(() => {
    return {
      matDrawerMode: (this.isHandset() || this.isSmall() ? 'over' : 'side') as 'over' | 'push' | 'side',
      matDrawerOpened: this.isHandset() || this.isSmall() ? false : true,
      title: this.title,
      testSite: this.siteContext.testSite(),
      localHost: this.siteContext.localHost(),
      productionSite: this.siteContext.productionSite()
    };
  });

  protected get vm() { return this.viewModel(); }

}
